import React from 'react';

const Connect = () => {
  return (
    <>
      {/* Connect Section */}
      <section id="connect" className="py-32 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-light text-center tracking-wide mb-4">CONNECT WITH US</h2>
          <div className="section-divider"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mt-16">
            <div data-aos="fade-right">
              <h3 className="text-xl font-light mb-8 tracking-wide">BOTSWALLE FOUNDATION</h3>
              <div className="space-y-4">
                <a 
                  href="https://www.instagram.com/botswalle_thesisterhood?igsh=MWQxZ3dwOGNqeG1xNw%3D%3D&utm_source=qr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-4 text-gray-700 hover:text-black transition-colors duration-300"
                >
                  <i className="fab fa-instagram w-6"></i>
                  <span>@botswalle_thesisterhood</span>
                </a>
                <a 
                  href="https://www.facebook.com/share/zE8oV1C6cgsiUoHz/?mibextid=LQQJ4d" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-4 text-gray-700 hover:text-black transition-colors duration-300"
                >
                  <i className="fab fa-facebook w-6"></i>
                  <span>Botswalle Foundation</span>
                </a>
                <a 
                  href="https://www.tiktok.com/@botswalle.the.sis?_t=8nSolFWQSMn&_r=1" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-4 text-gray-700 hover:text-black transition-colors duration-300"
                >
                  <i className="fab fa-tiktok w-6"></i>
                  <span>@botswalle.the.sis</span>
                </a>
                <a 
                  href="https://wa.me/27659678284" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-4 text-gray-700 hover:text-black transition-colors duration-300"
                >
                  <i className="fab fa-whatsapp w-6"></i>
                  <span>Business WhatsApp</span>
                </a>
              </div>
            </div>
            <div data-aos="fade-left">
              <h3 className="text-xl font-light mb-8 tracking-wide">KHOSIKHADI MMATLALA</h3>
              <div className="space-y-4">
                <a 
                  href="https://www.instagram.com/mmatlala.mudau?igsh=MXhxMGVvM3ZqbjdnZA%3D%3D&utm_source=qr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center space-x-4 text-gray-700 hover:text-black transition-colors duration-300"
                >
                  <i className="fab fa-instagram w-6"></i>
                  <span>@mmatlala.mudau</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 bg-white border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-gray-600">&copy; 2025 The House of Khosikhadi. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default Connect;